/* eslint-disable jsx-a11y/accessible-emoji */
import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import {
    Input, Button, Form
} from 'semantic-ui-react';
import { useCreateProperty, useUpdateProperty } from '~/properties';
import { getState } from '../../store';

const PropertyForm = props => {

    const { role } = getState().auth;
    const isAdmin = role === 'admin';

    const createProperty = useCreateProperty();
    const updateProperty = useUpdateProperty();

    const onSubmit = async values => {

        delete values.amenity_config;

        if (!props.initialValues) {

            createProperty.mutate(values);
        }
        else if (props.initialValues) {

            updateProperty.mutate({
                id: values.id,
                payload: values
            });
        }

        props.setModalOpen(false);

    };

    return (
        <FinalForm
            initialValues={props.initialValues}
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, pristine }) => (
                <Form onSubmit={handleSubmit}>
                    <Form.Field>
                        <label htmlFor='name'>Property Name</label>
                        <Field
                            name='name'
                            component={Input}
                            type='text'
                            placeholder='Property Name'
                        />
                    </Form.Field>

                    <Form.Field>
                        <label htmlFor='name'>Property Address</label>
                        <Field
                            name='property_address'
                            component={Input}
                            type='text'
                            placeholder='12345 NE 2nd Ave'
                        />
                    </Form.Field>

                    <Form.Field>
                        <label htmlFor='name'>Property City, State, Zip</label>
                        <Field
                            name='property_city_state_zip'
                            component={Input}
                            type='text'
                            placeholder='Miami FL, 33160'
                        />
                    </Form.Field>

                    <Form.Field>
                        <label htmlFor='name'>Phone Number</label>
                        <Field
                            name='phone_number'
                            component={Input}
                            type='text'
                            placeholder='Phone Number'
                        />
                    </Form.Field>

                    {isAdmin && (
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <label htmlFor='code'>Entrata Code</label>
                                <Field
                                    name='code'
                                    component={Input}
                                    type='text'
                                    placeholder='Entrata Code'
                                />
                            </Form.Field>
                            <Form.Field>
                                <label htmlFor='prefix'>Entrata Prefix</label>
                                <Field
                                    name='prefix'
                                    component={Input}
                                    type='text'
                                    placeholder='Entrata Prefix'
                                />
                            </Form.Field>
                        </Form.Group>
                    )}

                    <Form.Group widths='equal'>
                        <Form.Field>
                            <label htmlFor='dba'>DBA</label>
                            <Field
                                name='dba'
                                component={Input}
                                type='text'
                                placeholder='DBA'
                            />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor='legal_name'>Legal Name</label>
                            <Field
                                name='legal_name'
                                component={Input}
                                type='text'
                                placeholder='Legal Name'
                            />
                        </Form.Field>
                    </Form.Group>

                    <Form.Field>
                        <label htmlFor='court_address'>Court Address</label>
                        <Field
                            name='court_address'
                            component={Input}
                            type='text'
                            placeholder='Court Address'
                        />
                    </Form.Field>

                    <Form.Field>
                        <label htmlFor='signs_3day'>Signs 3 Day</label>
                        <Field
                            name='signs_3day'
                            component={Input}
                            type='text'
                            placeholder='Signs 3 Day'
                        />
                    </Form.Field>
                    <Form.Field>
                        <label htmlFor='city_state_zip'>City, State, Zip</label>
                        <Field
                            name='city_state_zip'
                            component={Input}
                            type='text'
                            placeholder='City, State, Zip'
                        />
                    </Form.Field>

                    <Form.Field>
                        <label htmlFor='property_assistant'>Property Assistant</label>
                        <Field
                            name='property_assistant'
                            component={Input}
                            type='text'
                            placeholder='Property Assistant'
                        />
                    </Form.Field>

                    <Form.Group widths='equal'>
                        <Form.Field>
                            <label htmlFor='judicial_circuit'>Judicial Circuit</label>
                            <Field
                                name='judicial_circuit'
                                component={Input}
                                type='text'
                                placeholder='Judicial Circuit'
                            />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor='county'>County</label>
                            <Field
                                name='county'
                                component={Input}
                                type='text'
                                placeholder='County'
                            />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor='clerk_of_courts'>Clerk Of Courts</label>
                            <Field
                                name='clerk_of_courts'
                                component={Input}
                                type='text'
                                placeholder='Clerk Of Courts'
                            />
                        </Form.Field>
                    </Form.Group>

                    <Form.Field>
                        <Button negative onClick={() => props.setModalOpen(false)}>
                            Cancel
                        </Button>
                        <Button floated='right' type='submit' disabled={submitting || pristine}>
                            Submit
                        </Button>
                    </Form.Field>
                </Form>
            )}
        />
    );
};

export default PropertyForm;

